module.exports = __webpack_public_path__ + "static/img/popup_pc_event1.34119c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup/soldoc/20250507/popup_pc_event1.png
// module id = 0Wz3
// module chunks = 0